module.exports = __webpack_public_path__ + "img/angry.dbc352a4.svg";